import { Pipe, PipeTransform } from '@angular/core';
import { Status } from 'common/components/data-block/data-block.component';

@Pipe({ name: 'boolToStatus' })
export class BoolToStatusPipe implements PipeTransform {
    transform(value: boolean): Status {
        return value ? 'success' : 'inactive';
    }
}
